// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-inbox{display:grid;grid-template-rows:auto auto;background-color:#fefefe;padding:20px;margin-bottom:15px;box-shadow:0 4px 10px rgba(0,0,0,.2);grid-gap:10px}.inbox-name{padding:2px}.inbox-queue{padding:2px}.inbox-queue-item{padding:5px;padding-left:25px}.inbox-wrapper{display:grid;grid-gap:5px;grid-template-columns:repeat(3, 1fr);grid-template-rows:auto;padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
